export default __webpack_public_path__ + "static/media/about1.a67a489a.webp";